import EventEmitter from 'eventemitter3';
import { Settings } from '../Settings';
import { MediaProducer } from '../engine/mediaproducer/MediaProducer';
import { StreamrWrapper } from './helpers/StreamrWrapper';
import { ViewerCounter } from './helpers/ViewerCounter';
export class StreamrTvBroadcaster extends EventEmitter {
    streamrWrapper;
    mediaProducer;
    viewerCounter;
    viewerInfoIntervalRef;
    streamPartId;
    constructor() {
        super();
        this.streamrWrapper = new StreamrWrapper();
        this.mediaProducer = new MediaProducer();
        this.viewerCounter = new ViewerCounter();
        this.mediaProducer.on('mediaPacketFragment', (mediaPacketFragment) => {
            this.streamrWrapper.publishMediaPacketFragment(mediaPacketFragment);
        });
        this.viewerCounter.on('countChanged', (count) => {
            if (this.streamPartId) {
                this.emit('viewerCountChanged', this.streamPartId, count);
            }
        });
        this.streamrWrapper.on('heartbeat', (heartbeat) => this.viewerCounter.handleHeartbeat(heartbeat));
        this.streamrWrapper.on('leave', (leave) => this.viewerCounter.handleLeave(leave));
    }
    async start(streamPartId) {
        console.log('StreamrTvBroadcaster::start()', streamPartId);
        this.streamPartId = streamPartId;
        await this.streamrWrapper.start(`${streamPartId}#0`);
        this.viewerCounter.start();
        this.viewerInfoIntervalRef = setInterval(() => {
            this.streamrWrapper.publishViewerInfo({
                viewerCount: this.viewerCounter.getCount(),
            });
        }, Settings.viewerInfoInterval);
    }
    async stop() {
        await this.streamrWrapper.stop();
        this.viewerCounter.stop();
        this.mediaProducer.stop();
        if (this.viewerInfoIntervalRef) {
            clearInterval(this.viewerInfoIntervalRef);
        }
    }
    async startMediaProducer(mediaStream) {
        await this.mediaProducer.start(mediaStream);
    }
    async stopMediaProducer() {
        this.mediaProducer.stop();
    }
    setVideoEncodingQuality(videoEncodingQuality) {
        console.log('StreamrTvBroadcaster::setVideoEncodingQuality()', videoEncodingQuality);
        this.mediaProducer.setVideoEncodingQuality(videoEncodingQuality);
    }
    getVideoEncodingQuality() {
        return this.mediaProducer.getVideoEncodingQuality();
    }
}
